import { render, staticRenderFns } from "./saccadic_rapid_naming.config.vue?vue&type=template&id=ca4b1d52"
import script from "./saccadic_rapid_naming.config.vue?vue&type=script&lang=js"
export * from "./saccadic_rapid_naming.config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports